import {
    successColor,
    primaryColor
} from "assets/jss/material-kit-pro-react.jsx";

const preloaderComponentStyle = {
        wrapper: {
            display: "block",
            position: "fixed",
            top: "0",
            width: "100%",
            height: "100%",
            opacity: "1",
            background: primaryColor[0],
            zIndex: "10000",

            "&>div": {
                height: "120px !important",
                width: "120px !important",
                position: "absolute",
                top: "40%",
                left: "0 !important",
                right: "0 !important",
                margin: "auto",

                "&>svg": {
                    color: successColor[0]
                }
            }
        }
};

export default preloaderComponentStyle;